import { createSlice } from '@reduxjs/toolkit'
import { ICommunicationHistory } from '@dataTypes/communicationHistory.type'
import { fetchCommunicationHistory } from '@store/actions'

interface PatientProfileState {
  communicationLog: ICommunicationHistory[]
  loading: {
    communication: boolean
  }
  error: {
    communication: string | null
  }
}

const initialState: PatientProfileState = {
  communicationLog: [],
  loading: {
    communication: false,
  },
  error: {
    communication: null,
  },
}

const patientProfileSlice = createSlice({
  name: 'patientProfile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Communication history
    builder
      .addCase(fetchCommunicationHistory.pending, (state) => {
        state.loading.communication = true
        state.error.communication = null
      })
      .addCase(fetchCommunicationHistory.fulfilled, (state, action) => {
        state.communicationLog = action.payload
        state.loading.communication = false
      })
      .addCase(fetchCommunicationHistory.rejected, (state, action) => {
        state.loading.communication = false
        state.error.communication = action.payload as string
      })
  },
})

export default patientProfileSlice.reducer
